<template>
  <div class="qh-page user-admin-page">
    <header class="user-header">
      <div>
        <span class="user-kicker">Administración</span>
        <h1>Gestión de usuarios</h1>
        <p>Crea cuentas, administra accesos y asigna perfiles dentro de Qhatu.</p>
      </div>
      <div class="user-summary" aria-label="Resumen de usuarios">
        <div><strong>{{ ListaUsuarios.length }}</strong><span>Usuarios</span></div>
        <div><strong>{{ ListaPerfilxUsuario.length }}</strong><span>Perfiles asignados</span></div>
      </div>
    </header>

    <section class="user-guide">
      <span class="guide-title">Acciones disponibles</span>
      <div class="guide-items">
        <span><i class="bi bi-person-plus text-primary"></i> Crear usuario</span>
        <span><i class="bi bi-pencil-square text-warning"></i> Editar perfil</span>
        <span><i class="bi bi-toggle-on text-success"></i> Activar</span>
        <span><i class="bi bi-toggle-off text-secondary"></i> Desactivar</span>
        <span><i class="bi bi-person-check text-primary"></i> Asignar perfil</span>
      </div>
    </section>

    <nav class="user-tabs" aria-label="Secciones de usuarios">
      <button type="button" :class="{ active: activeSection === 'usuarios' }" @click="activeSection = 'usuarios'">
        <i class="bi bi-people"></i>
        <span>Usuarios</span>
        <small>{{ ListaUsuarios.length }}</small>
      </button>
      <button type="button" :class="{ active: activeSection === 'perfiles' }" @click="activeSection = 'perfiles'">
        <i class="bi bi-person-badge"></i>
        <span>Perfiles asignados</span>
        <small>{{ ListaPerfilxUsuario.length }}</small>
      </button>
    </nav>

    <div class="container-fluid p-0">
      <section v-show="activeSection === 'usuarios'" class="user-workspace">
      <form @submit.prevent="Guardar">
        <section class="qh-panel">
          <div class="qh-panel-header">
            <div class="d-flex gap-3 align-items-center">
              <span class="qh-section-icon"><i class="bi bi-person-plus"></i></span>
              <div>
                <h2 class="qh-panel-title">Nuevo usuario</h2>
                <p class="qh-panel-copy">Completa la identidad, credenciales y datos principales del usuario.</p>
              </div>
            </div>
          </div>

          <div class="qh-panel-body qh-form-panel">
            <div class="section-kicker-wrap">
              <h5 class="section-kicker">Creación de usuario</h5>
              <p class="section-helper">Los campos obligatorios permiten registrar de inmediato la cuenta y dejarla lista para asignación de perfil.</p>
            </div>

            <div class="row g-3">
              <div class="col-12 col-lg-8">
                <div class="row g-3">
                  <div class="col-12 col-md-6 col-xl-4">
                    <label class="qh-label"><i class="bi bi-person-vcard"></i> Documento de identidad</label>
                    <input type="text" class="form-control" placeholder="Ej. 12345678" required v-model.trim="documentoIdentidad">
                    <small class="qh-help">Será usado como referencia de identificación del usuario.</small>
                  </div>

                  <div class="col-12 col-md-6 col-xl-4">
                    <label class="qh-label"><i class="bi bi-person-lines-fill"></i> Apellido paterno</label>
                    <input type="text" class="form-control" placeholder="Ej. Pérez" required v-model.trim="apellidoPaterno">
                  </div>

                  <div class="col-12 col-md-6 col-xl-4">
                    <label class="qh-label"><i class="bi bi-person-lines-fill"></i> Apellido materno</label>
                    <input type="text" class="form-control" placeholder="Ej. Gómez" required v-model.trim="apellidoMaterno">
                  </div>

                  <div class="col-12 col-md-6 col-xl-4">
                    <label class="qh-label"><i class="bi bi-person-fill"></i> Nombres</label>
                    <input type="text" class="form-control" placeholder="Ej. María Fernanda" required v-model.trim="nombre">
                  </div>

                  <div class="col-12 col-md-6 col-xl-4">
                    <label class="qh-label"><i class="bi bi-person-badge-fill"></i> Usuario</label>
                    <input type="text" class="form-control" placeholder="Ej. mperez@cliente.com" required v-model.trim="usuaio">
                    <small class="qh-help">Usa un identificador fácil de reconocer por el administrador.</small>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-4">
                <div class="password-card">
                  <div class="password-card-title">
                    <i class="bi bi-shield-lock"></i>
                    <span>Credenciales</span>
                  </div>

                  <div class="mb-3">
                    <label class="qh-label"><i class="bi bi-lock-fill"></i> Contraseña</label>
                    <div class="input-group">
                      <input :type="type" class="form-control" placeholder="Ingresar contraseña" required v-model="contraseña">
                      <button type="button" class="btn btn-outline-secondary" @click="type = type === 'password' ? 'text' : 'password'">
                        <i :class="type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                      </button>
                    </div>
                  </div>

                  <div>
                    <label class="qh-label"><i class="bi bi-lock-fill"></i> Repetir contraseña</label>
                    <div class="input-group">
                      <input :type="typeRepetir" class="form-control" required placeholder="Repetir contraseña" v-model="repetirContraseña">
                      <button type="button" class="btn btn-outline-secondary" @click="typeRepetir = typeRepetir === 'password' ? 'text' : 'password'">
                        <i :class="typeRepetir === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                      </button>
                    </div>

                    <div class="mt-2 password-feedback">
                      <small v-if="!repetirContraseña.length" class="text-muted">Confirma la contraseña para habilitar el guardado.</small>
                      <small v-else-if="passwordsMatch" class="text-success"><i class="bi bi-check-circle me-1"></i>Las contraseñas coinciden</small>
                      <small v-else class="text-danger"><i class="bi bi-exclamation-circle me-1"></i>Las contraseñas no coinciden</small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="action-strip">
                  <div class="action-copy">
                    <strong>Registro de usuario</strong>
                    <span>Guarda la cuenta y luego asígnale un perfil desde la sección inferior.</span>
                  </div>
                  <button type="submit" class="btn qh-btn qh-btn-primary action-button" :disabled="guardandoUsuario">
                    <span v-if="guardandoUsuario" class="spinner-border spinner-border-sm me-1"></span>
                    <i v-else class="bi bi-save"></i>
                    <span>{{ guardandoUsuario ? 'Guardando...' : 'Guardar usuario' }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </form>

      <section class="qh-panel">
        <div class="qh-panel-header">
          <div>
            <h2 class="qh-panel-title">Usuarios registrados</h2>
            <p class="qh-panel-copy">Consulta, busca y edita las cuentas existentes.</p>
          </div>
        </div>
        <div class="qh-panel-body">
          <TablaUsuario />
        </div>
      </section>

      </section>

      <section v-show="activeSection === 'perfiles'" class="user-workspace">
      <section class="qh-panel">
        <div class="qh-panel-header">
          <div>
            <h2 class="qh-panel-title">Asignación de perfil</h2>
            <p class="qh-panel-copy">Relaciona un perfil con un usuario para controlar sus permisos dentro de Qhatu.</p>
          </div>
        </div>

        <div class="qh-panel-body">
          <div class="row g-4 align-items-stretch">
            <div class="col-12 col-xl-7">
              <form @submit.prevent="GuardarAcceso" class="assign-card h-100">
                <div class="row g-3">
                  <div class="col-12 col-lg-6">
                    <label class="qh-label"><i class="bi bi-person-badge"></i> Perfil</label>
                    <div class="search-select">
                      <input v-model="busquedaPerfil" type="text" class="form-control"
                        placeholder="Buscar perfil..." autocomplete="off" required
                        @input="onPerfilInput" @focus="mostrarPerfiles = true"
                        @blur="ocultarOpciones('perfil')" />
                      <i class="bi bi-search search-select-icon"></i>
                      <ul v-if="mostrarPerfiles" class="search-select-options">
                        <li v-for="item in perfilesFiltrados" :key="item.idPerfil"
                          @mousedown.prevent="seleccionarPerfil(item)">
                          {{ item.perNombre }}
                        </li>
                        <li v-if="!perfilesFiltrados.length" class="empty">No se encontraron perfiles</li>
                      </ul>
                    </div>
                    <small class="qh-help">El perfil determina los módulos y acciones disponibles.</small>
                  </div>

                  <div class="col-12 col-lg-6">
                    <label class="qh-label"><i class="bi bi-person-workspace"></i> Usuario</label>
                    <div class="search-select">
                      <input v-model="busquedaUsuario" type="text" class="form-control"
                        placeholder="Buscar usuario..." autocomplete="off" required
                        @input="onUsuarioInput" @focus="mostrarUsuarios = true"
                        @blur="ocultarOpciones('usuario')" />
                      <i class="bi bi-search search-select-icon"></i>
                      <ul v-if="mostrarUsuarios" class="search-select-options">
                        <li v-for="item in usuariosFiltrados" :key="item.idUsuario"
                          @mousedown.prevent="seleccionarUsuario(item)">
                          {{ item.usuNombres }}
                        </li>
                        <li v-if="!usuariosFiltrados.length" class="empty">No se encontraron usuarios</li>
                      </ul>
                    </div>
                    <small class="qh-help">Selecciona la cuenta a la que deseas asignar el perfil.</small>
                  </div>
                </div>

                <div class="assign-actions">
                  <button class="btn btn-success qh-mini-save" :disabled="!canAssignProfile">
                    <i class="bi bi-check2-square"></i>
                    <span>Asignar perfil</span>
                  </button>
                </div>
              </form>
            </div>

            <div class="col-12 col-xl-5">
              <div class="assign-summary h-100">
                <div class="assign-summary-icon"><i class="bi bi-people-fill"></i></div>
                <h3>Asignación rápida</h3>
                <p>Primero registra el usuario y luego asígnale un perfil. El cambio se reflejará de inmediato en el listado inferior.</p>
                <ul>
                  <li>1 usuario seleccionado</li>
                  <li>1 perfil por registrar</li>
                  <li>Confirmación inmediata al guardar</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="qh-panel">
        <div class="qh-panel-header">
          <div>
            <h2 class="qh-panel-title">Perfiles asignados</h2>
            <p class="qh-panel-copy">Revisa las asociaciones vigentes y actualízalas cuando sea necesario.</p>
          </div>
        </div>
        <div class="qh-panel-body">
          <TablaUsuarios />
        </div>
      </section>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal2 from "sweetalert2";
import TablaUsuarios from "@/components/Configuracion/Tablas/TablaPerfilxUsuario.vue";
import TablaUsuario from "@/components/Configuracion/Tablas/TablaUsuario.vue";

export default {
  name: "PowerbyUsuario",
  components: {
    TablaUsuario,
    TablaUsuarios,
  },
  data() {
    return {
      activeSection: "usuarios",
      documentoIdentidad: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      nombre: "",
      usuaio: "",
      contraseña: "",
      repetirContraseña: "",
      type: "password",
      typeRepetir: "password",
      idUsuario: "",
      idPerfil: "",
      idUsuarios: "",
      usuarios: [],
      busquedaPerfil: "",
      busquedaUsuario: "",
      mostrarPerfiles: false,
      mostrarUsuarios: false,
      guardandoUsuario: false,
    };
  },
  computed: {
    ...mapGetters("acciones", ["ListaPerfil", "ListaUsuarios", "ListaPerfilxUsuario"]),
    passwordsMatch() {
      return this.contraseña.length > 0 && this.contraseña === this.repetirContraseña;
    },
    canSaveUser() {
      return [
        this.documentoIdentidad,
        this.apellidoPaterno,
        this.apellidoMaterno,
        this.nombre,
        this.usuaio,
        this.contraseña,
        this.repetirContraseña,
      ].every(Boolean) && this.passwordsMatch;
    },
    canAssignProfile() {
      return !!this.idPerfil && !!this.idUsuarios;
    },
    perfilesFiltrados() {
      const texto = this.normalizarTexto(this.busquedaPerfil);
      return this.ListaPerfil.filter((item) =>
        this.normalizarTexto(item.perNombre).includes(texto)
      );
    },
    usuariosFiltrados() {
      const texto = this.normalizarTexto(this.busquedaUsuario);
      return this.usuarios.filter((item) =>
        this.normalizarTexto(item.usuNombres).includes(texto)
      );
    },
  },
  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.cargarUsuarios();
    this.ListarUsuarios();
  },
  methods: {
    ...mapActions("acciones", ["ListarPerfilxUsuario", "ListarUsuarios"]),
    normalizarTexto(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    onPerfilInput() {
      this.idPerfil = "";
      this.mostrarPerfiles = true;
    },
    onUsuarioInput() {
      this.idUsuarios = "";
      this.mostrarUsuarios = true;
    },
    seleccionarPerfil(item) {
      this.idPerfil = item.idPerfil;
      this.busquedaPerfil = item.perNombre;
      this.mostrarPerfiles = false;
    },
    seleccionarUsuario(item) {
      this.idUsuarios = item.idUsuario;
      this.busquedaUsuario = item.usuNombres;
      this.mostrarUsuarios = false;
    },
    ocultarOpciones(tipo) {
      setTimeout(() => {
        if (tipo === "perfil") this.mostrarPerfiles = false;
        if (tipo === "usuario") this.mostrarUsuarios = false;
      }, 150);
    },
    cargarUsuarios() {
      this.axios.get("BIClientes/ListarUsuarios").then((r) => {
        this.usuarios = r.data || [];
      });
    },
    limpiarFormulario() {
      this.documentoIdentidad = "";
      this.apellidoPaterno = "";
      this.apellidoMaterno = "";
      this.nombre = "";
      this.usuaio = "";
      this.contraseña = "";
      this.repetirContraseña = "";
      this.type = "password";
      this.typeRepetir = "password";
    },
    validarFormularioUsuario() {
      const faltantes = [];
      if (!String(this.documentoIdentidad || "").trim()) faltantes.push("Documento de identidad");
      if (!String(this.apellidoPaterno || "").trim()) faltantes.push("Apellido paterno");
      if (!String(this.apellidoMaterno || "").trim()) faltantes.push("Apellido materno");
      if (!String(this.nombre || "").trim()) faltantes.push("Nombres");
      if (!String(this.usuaio || "").trim()) faltantes.push("Usuario (código de acceso)");
      if (!String(this.contraseña || "").trim()) faltantes.push("Contraseña");
      if (!String(this.repetirContraseña || "").trim()) faltantes.push("Repetir contraseña");

      if (faltantes.length > 0) {
        Swal2.fire({
          icon: "warning",
          title: "Campos incompletos",
          html: `<p>Por favor completa los siguientes campos obligatorios:</p><ul style="text-align: left; display: inline-block; margin-top: 0.5rem;">${faltantes.map(f => `<li><b>${f}</b></li>`).join("")}</ul>`,
          confirmButtonColor: "#0b5db7",
        });
        return false;
      }

      if (this.contraseña !== this.repetirContraseña) {
        Swal2.fire({
          icon: "warning",
          title: "Las contraseñas no coinciden",
          text: "Verifica que ambas contraseñas ingresadas sean exactamente iguales.",
          confirmButtonColor: "#0b5db7",
        });
        return false;
      }

      return true;
    },
    GuardarAcceso() {
      if (!this.canAssignProfile) return;
      const from = {
        idUsuario: this.idUsuarios,
        idPerfil: this.idPerfil,
        idUsuCreacion: this.idUsuario,
      };
      this.axios.post(`BIClientes/RegistrarAcceso`, from).then((r) => {
        if (r.data) {
          this.ListarPerfilxUsuario();
          this.idPerfil = "";
          this.idUsuarios = "";
          this.busquedaPerfil = "";
          this.busquedaUsuario = "";
          Swal2.fire({
            icon: "success",
            title: "Se registró el acceso",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal2.fire({
            icon: "error",
            title: "El usuario ya está asociado a un perfil",
            confirmButtonColor: "#0b5db7",
          });
        }
      });
    },
    Guardar() {
      if (!this.validarFormularioUsuario()) return;

      this.guardandoUsuario = true;
      const from = {
        idUsuario: Number(this.idUsuario) || 0,
        usuCodigo: this.usuaio,
        usuContrasena: this.contraseña,
        usuDocumento: this.documentoIdentidad,
        usuApePaterno: this.apellidoPaterno,
        usuApeMaterno: this.apellidoMaterno,
        usuNombres: this.nombre,
      };

      this.axios
        .post(`BIClientes/RegistrarUsuario`, from)
        .then((r) => {
          if (r.data === true) {
            this.limpiarFormulario();
            // Actualizar tabla de usuarios via Store
            this.ListarUsuarios();
            this.cargarUsuarios();
            Swal2.fire({
              icon: "success",
              title: "Usuario registrado",
              text: "Se registró el usuario correctamente.",
              timer: 2000,
              showConfirmButton: false,
            });
          } else if (typeof r.data === "string") {
            // El backend retorna: "Este usuario ya existe"
            Swal2.fire({
              icon: "warning",
              title: "Usuario no registrado",
              text: r.data,
              confirmButtonColor: "#0b5db7",
            });
          } else {
            Swal2.fire({
              icon: "warning",
              title: "Atención",
              text: r.data?.mensaje || "No se pudo registrar el usuario.",
              confirmButtonColor: "#0b5db7",
            });
          }
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.mensaje ||
            error?.response?.data?.message ||
            error?.response?.data ||
            error?.message ||
            "Error en el servidor al intentar registrar el usuario.";
          Swal2.fire({
            icon: "error",
            title: "Error en el registro",
            text: typeof msg === "string" ? msg : JSON.stringify(msg),
            confirmButtonColor: "#0b5db7",
          });
        })
        .finally(() => {
          this.guardandoUsuario = false;
        });
    },
  },
};
</script>

<style scoped>
.user-admin-page { display: grid; gap: .9rem; }
.user-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 1.25rem; }
.user-kicker { display: block; margin-bottom: .45rem; color: var(--qhatu-primary); font-size: .72rem; font-weight: 850; letter-spacing: .12em; text-transform: uppercase; }
.user-header h1 { margin: 0; color: #142c4a; font-size: clamp(1.65rem, 2.6vw, 2.15rem); font-weight: 800; }
.user-header p { margin: .35rem 0 0; color: var(--qhatu-muted); }
.user-summary { display: flex; gap: .55rem; }
.user-summary > div { min-width: 92px; min-height: 64px; padding: .6rem .8rem; border: 1px solid #d8e2ee; border-radius: 14px; background: #fff; display: grid; place-items: center; box-shadow: 0 6px 18px rgba(15, 23, 42, .04); }
.user-summary strong { color: var(--qhatu-primary); font-size: 1rem; line-height: 1; }
.user-summary span { color: #63738a; font-size: .68rem; text-align: center; }
.user-guide { display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; padding: .65rem .85rem; border: 1px solid #d8e2ee; border-radius: 12px; background: #fff; }
.guide-title { font-size: .74rem; font-weight: 800; color: #162b47; }
.guide-items { display: flex; align-items: center; gap: .8rem; flex-wrap: wrap; color: #596a80; font-size: .72rem; }
.guide-items span { display: inline-flex; align-items: center; gap: .28rem; }
.user-tabs { width: max-content; max-width: 100%; display: flex; gap: .35rem; padding: .35rem; border: 1px solid #d8e2ee; border-radius: 14px; background: #fff; }
.user-tabs button { min-height: 44px; border: 0; border-radius: 11px; padding: .55rem .9rem; background: transparent; color: #66768b; display: inline-flex; align-items: center; gap: .5rem; font-weight: 750; }
.user-tabs button small { min-width: 25px; height: 25px; padding-inline: .35rem; display: inline-grid; place-items: center; border-radius: 999px; background: #eef2f7; color: #65758a; }
.user-tabs button.active { background: linear-gradient(135deg, #0759b7, #0b73ca); color: #fff; box-shadow: 0 8px 20px rgba(7, 89, 183, .22); }
.user-tabs button.active small { background: rgba(255,255,255,.2); color: #fff; }
.user-workspace { display: grid; gap: .9rem; }
.qh-user-page .qh-panel { margin-bottom: 1.15rem; }
.qh-form-panel { display: grid; gap: 1rem; }
.section-kicker-wrap { display: grid; gap: .2rem; }
.section-kicker { margin: 0; font-weight: 800; color: #5f6f84; text-transform: uppercase; letter-spacing: .02em; }
.section-helper { margin: 0; color: var(--qhatu-muted); font-size: .92rem; }
.qh-label { display: flex; align-items: center; gap: .5rem; margin-bottom: .45rem; font-size: .86rem; font-weight: 800; text-transform: uppercase; color: #22324a; }
.qh-label i { color: #6d7b8d; font-size: 1rem; }
.qh-help { display: inline-block; margin-top: .35rem; color: var(--qhatu-muted); font-size: .77rem; }
.password-card { height: 100%; background: linear-gradient(180deg, #f8fbff, #ffffff); border: 1px solid #d7e4f1; border-radius: 16px; padding: 1rem; box-shadow: 0 12px 24px rgba(15, 23, 42, .05); }
.password-card-title { display: flex; align-items: center; gap: .55rem; margin-bottom: 1rem; font-size: .95rem; font-weight: 800; color: var(--qhatu-primary-dark); }
.password-card-title i { font-size: 1.05rem; }
.password-feedback { min-height: 20px; }
.action-strip { display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin-top: .35rem; padding: 1rem 1.1rem; border: 1px solid #dbe6f2; border-radius: 16px; background: #fbfdff; }
.action-copy { display: grid; gap: .15rem; }
.action-copy strong { color: #22324a; font-size: .98rem; }
.action-copy span { color: var(--qhatu-muted); font-size: .85rem; }
.action-button { min-width: 240px; min-height: 50px; }
.assign-card { display: flex; flex-direction: column; justify-content: space-between; gap: 1rem; padding: 1rem; border: 1px solid #dbe6f2; border-radius: 16px; background: #fbfdff; }
.search-select { position: relative; }
.search-select .form-control { padding-right: 2.75rem; }
.search-select-icon { position: absolute; top: 50%; right: 1rem; transform: translateY(-50%); color: #718096; pointer-events: none; }
.search-select-options { position: absolute; z-index: 40; top: calc(100% + 5px); left: 0; right: 0; max-height: 220px; overflow-y: auto; margin: 0; padding: .35rem; list-style: none; border: 1px solid #d5e1ee; border-radius: 12px; background: #fff; box-shadow: 0 14px 30px rgba(15, 23, 42, .14); }
.search-select-options li { padding: .65rem .75rem; border-radius: 9px; color: #334155; cursor: pointer; }
.search-select-options li:hover { background: #eaf4ff; color: var(--qhatu-primary); }
.search-select-options li.empty { color: #718096; cursor: default; }
.search-select-options li.empty:hover { background: transparent; color: #718096; }
.assign-actions { display: flex; justify-content: flex-end; }
.qh-mini-save { min-height: 48px; border-radius: 12px; display: inline-flex; align-items: center; gap: .55rem; padding-inline: 1.15rem; }
.assign-summary { height: 100%; border: 1px dashed #c8d7e8; border-radius: 16px; background: linear-gradient(180deg, #ffffff, #f7fbff); padding: 1.2rem; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; }
.assign-summary-icon { width: 72px; height: 72px; border-radius: 20px; display: grid; place-items: center; background: rgba(11, 93, 183, .10); color: var(--qhatu-primary); font-size: 2rem; margin-bottom: .8rem; }
.assign-summary h3 { margin: 0 0 .35rem; font-size: 1.05rem; font-weight: 800; color: #22324a; }
.assign-summary p { margin-bottom: .8rem; color: var(--qhatu-muted); max-width: 340px; }
.assign-summary ul { margin: 0; padding-left: 1rem; text-align: left; color: #51627b; font-size: .9rem; }
.assign-summary li + li { margin-top: .3rem; }
.form-control, .form-select { min-height: 54px; border-radius: 14px; }
.input-group > .form-control { min-height: 54px; }
.input-group > .btn { min-width: 52px; }
button:disabled { opacity: .68; cursor: not-allowed; }
@media (max-width: 991.98px) {
  .user-header { flex-direction: column; }
  .user-summary { width: 100%; }
  .user-summary > div { flex: 1; }
  .user-tabs { width: 100%; }
  .user-tabs button { flex: 1; justify-content: center; }
  .action-strip { flex-direction: column; align-items: stretch; }
  .action-button { min-width: 100%; width: 100%; }
  .assign-actions { justify-content: stretch; }
  .qh-mini-save { width: 100%; justify-content: center; }
}
@media (max-width: 575.98px) {
  .user-summary { display: grid; grid-template-columns: 1fr 1fr; }
  .user-guide { align-items: flex-start; }
  .guide-items { gap: .55rem; }
  .user-tabs { display: grid; grid-template-columns: 1fr; }
}
</style>
